import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Filter from "../Landing/Filter.js";
import Button from "react-bootstrap/Button";
import getSymbolFromCurrency from "currency-symbol-map";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import img1 from "../../Assets/images/where/img1.png";
import img2 from "../../Assets/images/where/img2.png";
import img3 from "../../Assets/images/where/img3.png";
import img4 from "../../Assets/images/where/img4.png";
import img5 from "../../Assets/images/where/img5.png";
import img6 from "../../Assets/images/where/img6.png";
import img7 from "../../Assets/images/where/img7.png";
import img8 from "../../Assets/images/where/img8.png";
import img9 from "../../Assets/images/where/img9.png";
import img10 from "../../Assets/images/where/img10.png";
import img11 from "../../Assets/images/where/img11.png";
import img12 from "../../Assets/images/where/img12.png";
import img13 from "../../Assets/images/where/img13.png";
import img14 from "../../Assets/images/where/img14.png";
import { getAllHostingDetailhooks, getHostedDatas } from "../../Hooks/useUserHostingHook.js";
import {
  getUserDatas,
  getUserEmail,
  getalllandcmsdata,
  getusersdatahooks,
} from "../../Hooks/useUserHook.js";
import {
  addwishlist,
  experiencehostingfilterhook,
  getwishlist,
} from "../../Hooks/filterHook";
import LottieView from "react-lottie";
import LottieImg from "../../Assets/images/lotties/loader.json";
import Cookies from "universal-cookie";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "react-js-loader";
import HeadSection from "./HeadSection.js";
import Filters from "./Filters.js";
import VideoSec from "./VideoSec.js";
import { currency } from "../../config/currencycode.js";
import { getExperienceDatas } from "../../Hooks/useUserExperienceHook.js";
import ExpListCard from "./ExpListCard.js";
import Testimonials from "./Testimonials.js";
import NewNavbar from "./NewNavbar.js";
import {toast, Toaster} from "react-hot-toast";
import { toastOptions } from "../../config/env.js";
import { Link, useNavigate } from "react-router-dom";
const Header = React.lazy(() => import("../Common/Header"));
const Footer = React.lazy(() => import("../Common/Footer"));

const Card = React.lazy(() => import("../../Components/Landing/Card"));


const Land = () => {
  const cookies = new Cookies();
  let { useremail } = useParams();
  console.log("useremail>>>>>>>>>>>>", useremail);
  console.log("onew userrrrrrrrrrr")
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [hostedDatas, setHostedDatas] = useState([]);
  const [filterdata, setFilterdata] = useState([]);
  const [isfilter, setIsfilter] = useState(false);
  const [isicon, setIsicon] = useState(false);
  const [iconfiltereddata, setIconfiltereddata] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [isfilterbutton, setIsfilterbutton] = useState(false);
  const [buttonfiltereddata, setButtonfiltereddata] = useState([]);
  const [userDatas, setUserDatas] = useState({});
  const [wishedlist, setWishedlist] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [selectedcurrency, setSelectedcurrency] = useState(
    localStorage.getItem("PCURENCY") ? localStorage.getItem("PCURENCY") : "USD"
  );
  const [selectedsymbol, setSelectedsymbol] = useState("");

  //Experience
  const [selection, setSelection] = useState("Stay");
  const [experienceDatas, setExperienceDatas] = useState([]);
  const [exhasMore, setExhasMore] = useState(true);
  const [exstart, setExstart] = useState(0);
  const [exend, setExend] = useState(20);
  const [exisfilter, setExisfilter] = useState(false);
  const [exfiltereddata, setExfiltereddata] = useState([]);
  const [wishref, setWishref] = useState(1);

  const [wishrefsub, setWishrefsub] = useState(1);


  const [cmsdata, setCmsData] = useState([])

  const navigate = useNavigate();
  useEffect(() => {
    getExperienceDatas(start, end).then((data) => {
      console.log("dsjvfjhasdfgjhadfyu", data);
      setExperienceDatas(data);
    });
  }, []);

  const exfetchData = () => {
    getExperienceDatas(experienceDatas.length, end).then((data) => {
      console.log("THE NEXT 10 DATAS :", data);
      if (data != "") {
        setExperienceDatas(experienceDatas.concat(data));
      } else {
        setExhasMore(false);
      }
    });
  };


  useEffect(() => {
    async function fetchdata() {
      const data = getUserEmail();
      var userdata = await getusersdatahooks(data);
      // setUserDatas(userdata);
    }
    fetchdata();
  }, []);


  useEffect(() => {
    async function fetchdata() {
      const res = await getalllandcmsdata();
      console.log("res cmsdata", res)
      if (res?.data?.type == "success") {
        setCmsData(res?.data?.data)
      }
    }
    fetchdata();
  }, [])

  const filterdataexperience = async () => {
    console.log("experience filter data");
    //  setIsfilter(true);
    // setTopsec(false)
    // console.log("date", startDate, endDate);
    let payload = {};
    // {
    //   country: country,
    //   checkInDate: startDate,
    //   checkOutDate: endDate,
    //   adult: adult,
    //   children: children,
    //   infants: infants,
    //   pets: pets,
    //   guest: (adult + children)
    //   //  startdate : startDate,
    //   //  enddate : endDate
    //   //  count : counter
    // }
    console.log("payload", payload);
    await experiencehostingfilterhook(payload)
      .then((data) => {
        console.log("filter return : ", data);
        // props.onSetFilteredData(data);
      })
      .catch((e) => console.log("filter return error", e));
  };

  //Experience End

  useEffect(() => {
    getusersdatahooks(getUserEmail()).then((data) => {
      setUserDatas(data);
    });
    // getHostedDatas(start, end, selectedcurrency).then((data) => {
    //   var symbol = getSymbolFromCurrency(selectedcurrency);
    //   console.log("Symbol", symbol);
    //   setSelectedsymbol(symbol);
    //   // showLoader();
    //   setHostedDatas(data);
    //   // hideLoader();
    // });
    getAllHostingDetailhooks().then((data) => {
      setHostedDatas(data)
    })
  }, [useremail, start]);

  useEffect(() => {
    // console.log("CurrencyList" , cc.codes())
    // showLoader()
    getHostedDatas(start, end, selectedcurrency).then((data) => {
      console.log('datasdfasdfasd', data)
      var symbol = getSymbolFromCurrency(selectedcurrency);
      console.log("Symbol", symbol);
      setSelectedsymbol(symbol);
      setHostedDatas(data);
      // hideLoader()
    });
  }, [selectedcurrency]);

  const filteredData = (val) => {
    console.log("value -----------", val.data);
    if (val.data.type == "success") setIsfilter(true);
    setFilterdata(val.data.record);
  };

  const icondata = (val) => {
    console.log("valueeeee", val);
    // if(val.data.type == 'success')
    setIsicon(true);
    setIconfiltereddata(val.data.record);
  };

  const filterbutton = (val) => {
    // console.log("props" , val.data);
    if (val.data.type == "success") setIsfilterbutton(true);
    setButtonfiltereddata(val.data.record);
  };

  // const wishlistarray = async (id, mail) => {
  //   if (mail) {
  //     let payload = {
  //       roomid: id,
  //       emailid: mail,
  //     };
  //     await addwishlist(payload)
  //       .then(async (data) => {
  //         console.log("wishlist r eturn: ", data, hostedDatas, userDatas);
  //         let usr = btoa(JSON.stringify(data.data.record));
  //         localStorage.setItem("USRDT" , usr);
  //         cookies.set(
  //           "User-Datas",
  //           data.data.record,
  //           { path: "/" },
  //           { expires: new Date(Date.now() + 600000) }
  //         );

  //         // setUserDatas({});
  //         // setHostedDatas([]);
  //         // let wishlist = await getwishlist(mail);
  //         // console.log("wishlist return data", wishlist.data.record);
  //           getusersdatahooks(mail).then((usrdata) => {
  //             setTimeout(()=>{
  //               setUserDatas(usrdata);
  //               setWishref((wish) => wish+1)
  //             },10)
  //             return usrdata;

  //             // setTimeout(setUserDatas(usrdata) , 200)
  //            // setTimeout(setWishref(wishref+1) , 100);
  //             // setHostedDatas(hostedDatas);
  //           });
  //         // getHostedDatas(start, end , selectedcurrency).then((data) => {
  //         //   showLoader();
  //         //   setHostedDatas(data);
  //         //   hideLoader();
  //         // });
  //       })
  //       .catch((e) => console.log("wishlist return error", e));
  //   } else {
  //   }
  // };

  const wishlistarray = async (id, mail, title, filter) => {
    if(filter == "add") {
      toast.success(`${title} add your wishlist`, toastOptions)
    } else if (filter == "remove") {
      toast.error(`${title} remove your wishlist`, toastOptions)
    }
    // filter
    console.log("dsfasdfsadf", title)
    if (mail) {
      let payload = {
        roomid: id,
        emailid: mail,
      };
      var data = await addwishlist(payload);
      console.log("wishlist r eturn: ", data, hostedDatas, userDatas);
      let usr = btoa(JSON.stringify(data.data.record));
      localStorage.setItem("USRDT", usr);
      cookies.set(
        "User-Datas",
        data.data.record,
        { path: "/" },
        { expires: new Date(Date.now() + 600000) }
      );
      // .then(async (data) => {
      //   console.log("wishlist r eturn: ", data, hostedDatas, userDatas);
      //   let usr = btoa(JSON.stringify(data.data.record));
      //   localStorage.setItem("USRDT" , usr);
      //   cookies.set(
      //     "User-Datas",
      //     data.data.record,
      //     { path: "/" },
      //     { expires: new Date(Date.now() + 600000) }
      //   );

      var usrdata = await getusersdatahooks(mail);
      // getusersdatahooks(mail).then((usrdata) => {
      //   setTimeout(()=>{
      setUserDatas(usrdata);
      setWishref((wish) => wish + 1);
      // },10)
      
      return usrdata;

      // });

      // })
      // .catch((e) => console.log("wishlist return error", e));
    } else {
    }
  };

  const showLoader = () => {
    document.getElementsByTagName("body")[0].style.height = "100vh";
    document.getElementsByTagName("body")[0].classList.add("overflow_hidden");
    document.getElementById("logo_overlay").style.opacity = 0.2;
    document.getElementById("loader_div").classList.remove("d-none");
    document.getElementById("loader_div").classList.add("d-flex");
  };
  const hideLoader = () => {
    document
      .getElementsByTagName("body")[0]
      .classList.remove("overflow_hidden");
    document.getElementById("logo_overlay").style.opacity = 1;
    document.getElementById("loader_div").classList.remove("d-flex");
    document.getElementById("loader_div").classList.add("d-none");
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: LottieImg,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const whereImg = [
    {
      img: [
        { imginner: img1 },
        { imginner: img2 },
        { imginner: img3 },
        { imginner: img6 },
        { imginner: img2 },
        { imginner: img3 },
        { imginner: img5 },
        { imginner: img1 },
        { imginner: img6 },
        { imginner: img12 },
        { imginner: img12 },
        { imginner: img13 },
      ],
    },
    { img: [{ imginner: img2 }, { imginner: img4 }] },
    { img: [{ imginner: img3 }, { imginner: img1 }, { imginner: img6 }] },
    { img: [{ imginner: img4 }, { imginner: img12 }, { imginner: img13 }] },

    { img: [{ imginner: img6 }, { imginner: img2 }, { imginner: img3 }] },
    { img: [{ imginner: img7 }, { imginner: img4 }] },
    { img: [{ imginner: img5 }, { imginner: img1 }, { imginner: img6 }] },
    { img: [{ imginner: img8 }, { imginner: img12 }, { imginner: img13 }] },

    { img: [{ imginner: img9 }, { imginner: img2 }, { imginner: img3 }] },
    { img: [{ imginner: img10 }, { imginner: img4 }] },
    { img: [{ imginner: img11 }, { imginner: img1 }, { imginner: img6 }] },
    { img: [{ imginner: img12 }, { imginner: img12 }, { imginner: img13 }] },

    { img: [{ imginner: img13 }, { imginner: img2 }, { imginner: img3 }] },
    { img: [{ imginner: img14 }, { imginner: img4 }] },
    { img: [{ imginner: img5 }, { imginner: img1 }, { imginner: img6 }] },

    { img: [{ imginner: img6 }, { imginner: img12 }, { imginner: img13 }] },
  ];

  const refresh = (setHostedDatas) => {};

  const fetchData = () => {
    getHostedDatas(hostedDatas.length, end, selectedcurrency).then((data) => {
      console.log("THE NEXT 10 DATAS :", data);
      if (data != "") {
        setHostedDatas(hostedDatas.concat(data));
      } else {
        setHasMore(false);
      }
    });
  };

  // const refresh = async()=> {
  //   const data = getUserEmail();
  //     var userdata = await getusersdatahooks(data);
  // }


  const cmsFilter = (data) => {
    try {
      let filterdata = cmsdata?.find(
        (el) => el.Identifier == data && el?.status == "active"
      );
      console.log("filterdata_filterdata", filterdata, filterdata?.updatedAt);
      return filterdata;
    } catch (e) {
      console.log("cmsFilter_err", e);
    }
  };


  return (
    <>
      <div id="loader_div" className="d-none">
        <LottieView
          className="logo_load"
          options={defaultOptions}
          height={200}
          width={200}
        />
        <span className="spin_round" />
      </div>
      <div className="logo_overlay landing_page" id="logo_overlay">
        <div className="overlaybg" />
        <div>
          {/* <Header onSetFilteredData={filteredData} email={useremail} /> */}

          {/* <Filter onSetIcondata={icondata} /> */}
          <NewNavbar />
          <HeadSection
            onSetcurr={(data) => {
              setSelectedcurrency(data);
            }}
          />
          <Filters
            onSetFilteredData={filteredData}
            email={useremail}
            selected={(data) => setSelection(data)}
          />

          <VideoSec />

          <div className="featured_properties my-5">
            <div className="container container_custom">
              <div className="header_sec mb-4">
                <div className="fst_sec">
                  <h3>{cmsFilter("land_banner07")?.Title}</h3>
                  <p>
                  {cmsFilter("land_banner07")?.Content}
                  </p>
                </div>


                <div className="snd_sec">
                  <div className="view-all-properties">
                    <Button variant="primary"
                      onClick={() => {
                        navigate("/landing-map");
                      }}>View all properties</Button>
                  </div>
                </div>
              </div>
              {selection == "Stay" && (hasMore || hostedDatas.length > 0) && (
                <InfiniteScroll
                  dataLength={hostedDatas.length} //This is important field to render the next data
                  next={() => {
                    fetchData();
                  }}
                  hasMore={hasMore}
                  loader={
                    <Loader
                      type="bubble-loop"
                      bgColor={"#000000"}
                      title={"Loading"}
                      color={"#000000"}
                      size={50}
                    />
                  }
                  className="custom_scroll"
                  // scrollableTarget="scrollableDiv"
                  endMessage={
                    <p
                      style={{ textAlign: "center", fontFamily: "Courier New" }}
                    >
                      <h5>Yay! You have seen it all</h5>
                    </p>
                  }
                  // below props only if you need pull down functionality
                  refreshFunction={refresh}
                  // pullDownToRefresh
                  // pullDownToRefreshThreshold={50}
                  // pullDownToRefreshContent={
                  //     <h3 style={{ textAlign: 'center' }}>&#8595; Pull down to refresh</h3>
                  // }
                  // releaseToRefreshContent={
                  //     <h3 style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
                  // }
                >
                  <div className="containerr container_custom mh-100vh-filterheader-footer mb-4">
                    {wishref && (
                      <div className="d-gridd card-55 row">
                        {// isfilterbutton ? buttonfiltereddata && buttonfiltereddata.map((i) => <Card data = {i}/>)
                        isfilter
                          ? filterdata &&
                            filterdata.map((i) => (
                              <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4 mb-3">
                                <Card
                                  data={i}
                                  symbol={selectedsymbol}
                                  userData={userDatas}
                                />
                              </div>
                            ))
                          : isicon
                          ? iconfiltereddata &&
                            iconfiltereddata.map((i) => (
                              <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4 mb-3">
                                <Card
                                  data={i}
                                  symbol={selectedsymbol}
                                  userData={userDatas}
                                />
                              </div>
                            ))
                          : hostedDatas &&
                            hostedDatas.map((i) => (
                              <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4 mb-3">
                                <Card
                                  symbol={selectedsymbol}
                                  data={i}
                                  userData={userDatas}
                                  wishlistarray={wishlistarray}
                                />
                              </div>
                            ))}
                      </div>
                    )}
    
                  </div>
                </InfiniteScroll>
              )}
              {console.log('hostedDatas_hostedDatas', hostedDatas)}
              {selection == "Stay" && !hasMore && hostedDatas.length == 0 && (
                <p className="no_data_host_exp">No Data Found..</p>
              )}

              {selection == "Experience" &&
                (exhasMore || experienceDatas.length > 0) && (
                  <InfiniteScroll
                    dataLength={experienceDatas.length} //This is important field to render the next data
                    next={() => {
                      exfetchData();
                    }}
                    hasMore={exhasMore}
                    loader={
                      <Loader
                        type="bubble-loop"
                        bgColor={"#000000"}
                        title={"Loading"}
                        color={"#000000"}
                        size={50}
                      />
                    }
                    className="custom_scroll"
                    endMessage={
                      <p className="text-center pb-5">
                        <b>Yay! You have seen it all</b>
                      </p>
                    }
                    // below props only if you need pull down functionality
                    refreshFunction={refresh}
                    // pullDownToRefresh
                    // pullDownToRefreshThreshold={50}
                    // pullDownToRefreshContent={
                    //     <h3 style={{ textAlign: 'center' }}>&#8595; Pull down to refresh</h3>
                    // }
                    // releaseToRefreshContent={
                    //     <h3 style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
                    // }
                  >
                    <div className="containerr container_custom mb-5">
                      <div className="d-gridd card-55 row">
                        {experienceDatas &&
                          experienceDatas.map((i) => (
                            <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4 mb-3">
                              <ExpListCard
                                data={i}
                                symbol={selectedsymbol}
                                userData={userDatas}
                              />
                            </div>
                          ))}
                      </div>
                    </div>
                  </InfiniteScroll>
                )}

              {selection == "Experience" &&
                !exhasMore &&
                experienceDatas.length == 0 && (
                  <p className="no_data_host_exp">No Data Found..</p>
                )}
            </div>
          </div>
         {cmsFilter("land_banner05")?.ContentArray?.length > 0&& <Testimonials />}
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Land;
